import type { ExpertDataServiceOption } from './GlobalHeader.types';

/**
 * External URLs for navigation
 */
export const EXTERNAL_URLS = {
  AGENCY_CATALOG: 'https://agency-catalog.centific.com',
} as const;

/**
 * Expert Data Service dropdown menu options
 * All options redirect to the data catalog page
 */
export const EXPERT_DATA_SERVICE_OPTIONS: readonly ExpertDataServiceOption[] = [
  { id: 'model-development', label: 'Model Development' },
  { id: 'safety-ai', label: 'Safety AI' },
  { id: 'synthetic', label: 'Synthetic' },
] as const;
